module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/features/5-e1d992acbcdb5d6d7f3c5c2dfb7c3e94.svg";